/**
 * Type of AD.
 */
export enum MKAdType {
    /**
     * Preroll.
     */
    Preroll = "preroll",

    /**
     * Midroll.
     */
    Midroll = "midroll",

    /**
     * Postroll.
     */
    Postroll = "postroll",

    /**
     * Unknown.
     */
    Unknown = "unknown"
}